import React from 'react'

class Palette extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.colors !== this.props.colors || nextProps.selectedColor !== this.props.selectedColor
  }

  renderColorPickers() {
    return this.props.colors.map((color) => {
      return (
        <PaletteColor
          key={color.replace('#', '')}
          color={color}
          selectedColor={this.props.selectedColor}
          onSelect={this.props.onSelect}
        />
      )
    })
  }

  render() {
    return <div className="palette">{this.renderColorPickers()}</div>
  }
}

class PaletteColor extends React.PureComponent {
  onClickHandler = () => {
    this.props.onSelect(this.props.color)
  }

  render() {
    const { color, selectedColor } = this.props
    const isSelected = selectedColor === color
    return (
      <div
        className={`color-picker${isSelected ? ' selected' : ''}`}
        key={color.replace('#', '')}
        style={{
          backgroundColor: color,
          borderRadius: '360px',
        }}
        onClick={this.onClickHandler}
      />
    )
  }
}

export default Palette



// WEBPACK FOOTER //
// ./src/components/Palette.js